"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _peractoConfig = require("@peracto/peracto-config");

var _TextInput = _interopRequireDefault(require("@peracto/peracto-editor-ui/dist/TextInput"));

var _PlainTextarea = _interopRequireDefault(require("@peracto/peracto-editor-ui/dist/PlainTextarea"));

var _Select = _interopRequireDefault(require("@peracto/peracto-editor-ui/dist/Select"));

var _Textarea = _interopRequireDefault(require("@peracto/peracto-editor-ui/dist/Textarea"));

var _Checkbox = _interopRequireDefault(require("@peracto/peracto-editor-ui/dist/Checkbox"));

var _Slider = _interopRequireDefault(require("@peracto/peracto-editor-ui/dist/Slider"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faTrash = require("@fortawesome/pro-regular-svg-icons/faTrash");

var _faArrowsV = require("@fortawesome/pro-regular-svg-icons/faArrowsV");

var _faPlusCircle = require("@fortawesome/pro-regular-svg-icons/faPlusCircle");

var _faCheck = require("@fortawesome/pro-regular-svg-icons/faCheck");

var _faChevronUp = require("@fortawesome/pro-regular-svg-icons/faChevronUp");

var _faChevronDown = require("@fortawesome/pro-regular-svg-icons/faChevronDown");

var _startCase = _interopRequireDefault(require("lodash/startCase"));

var _AccordionItemSort = _interopRequireDefault(require("./AccordionItemSort"));

var _core = require("@chakra-ui/core");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var AccordionForm = function AccordionForm(_ref) {
  var _theme$colors;

  var _onChange = _ref.onChange,
      _ref$state = _ref.state,
      _ref$state$headerColo = _ref$state.headerColour,
      headerColour = _ref$state$headerColo === void 0 ? '#000000' : _ref$state$headerColo,
      headerHoverColour = _ref$state.headerHoverColour,
      _ref$state$headerFont = _ref$state.headerFontSize,
      headerFontSize = _ref$state$headerFont === void 0 ? 3 : _ref$state$headerFont,
      _ref$state$headerBack = _ref$state.headerBackgroundColour,
      headerBackgroundColour = _ref$state$headerBack === void 0 ? 'transparent' : _ref$state$headerBack,
      headerBackgroundHoverColour = _ref$state.headerBackgroundHoverColour,
      _ref$state$headerFont2 = _ref$state.headerFont,
      headerFont = _ref$state$headerFont2 === void 0 ? 'body' : _ref$state$headerFont2,
      _ref$state$headerFont3 = _ref$state.headerFontWeight,
      headerFontWeight = _ref$state$headerFont3 === void 0 ? 'normal' : _ref$state$headerFont3,
      _ref$state$borderColo = _ref$state.borderColour,
      borderColour = _ref$state$borderColo === void 0 ? '' : _ref$state$borderColo,
      _ref$state$accordion = _ref$state.accordion,
      accordion = _ref$state$accordion === void 0 ? [] : _ref$state$accordion,
      selectedAccordionIndex = _ref$state.selectedAccordionIndex;
  var config = (0, _peractoConfig.useConfig)();

  var _ref2 = config.get('editorConfig') || [],
      theme = _ref2.theme;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      manageItemOrder = _useState2[0],
      setManageItemOrder = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showHeaderOptions = _useState4[0],
      setShowHeaderOptions = _useState4[1];

  var themeColours = [];

  if (theme !== null && theme !== void 0 && (_theme$colors = theme.colors) !== null && _theme$colors !== void 0 && _theme$colors.brand) {
    for (var _i2 = 0, _Object$entries = Object.entries(theme.colors.brand); _i2 < _Object$entries.length; _i2++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2),
          label = _Object$entries$_i[0],
          colour = _Object$entries$_i[1];

      themeColours.push({
        label: (0, _startCase["default"])(label),
        value: colour
      });
    }
  }

  var themeFonts = [];

  if (theme !== null && theme !== void 0 && theme.fonts) {
    Object.keys(theme.fonts).map(function (font) {
      return themeFonts.push({
        label: (0, _startCase["default"])(font),
        value: font
      });
    });
  }

  var DEFAULT_ACCORDION_ITEM = {
    anchor: '',
    text: '',
    label: '',
    openByDefault: false
  };
  (0, _react.useEffect)(function () {
    return function () {
      _onChange({
        selectedAccordionIndex: null
      });
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-sm w-100 mb-2 ".concat(manageItemOrder ? 'btn-success' : 'btn-secondary'),
    onClick: function onClick() {
      setManageItemOrder(!manageItemOrder);
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: manageItemOrder ? _faCheck.faCheck : _faArrowsV.faArrowsV,
    className: "mr-2"
  }), ' ', manageItemOrder ? 'Done' : 'Manage Item Order'), manageItemOrder ? /*#__PURE__*/_react["default"].createElement(_AccordionItemSort["default"], {
    accordion: accordion,
    onChange: _onChange
  }) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-sm w-100 mb-2 btn-outline-secondary text-white",
    onClick: function onClick() {
      setShowHeaderOptions(!showHeaderOptions);
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: showHeaderOptions ? _faChevronUp.faChevronUp : _faChevronDown.faChevronDown,
    className: "mr-2"
  }), ' ', showHeaderOptions ? 'Hide' : 'Show', " Heading Options"), /*#__PURE__*/_react["default"].createElement(_core.Stack, {
    h: showHeaderOptions ? 'auto' : 0,
    overflow: showHeaderOptions ? 'visible' : 'hidden'
  }, /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: "Heading Text Colour",
    options: [].concat(themeColours),
    value: headerColour,
    onChange: function onChange(e) {
      _onChange({
        headerColour: e.value
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: "Heading Text Hover Colour",
    options: [].concat(themeColours),
    value: headerHoverColour,
    onChange: function onChange(e) {
      _onChange({
        headerHoverColour: e.value
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: "Heading Background Colour",
    options: [].concat(themeColours),
    value: headerBackgroundColour,
    onChange: function onChange(e) {
      _onChange({
        headerBackgroundColour: e.value
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: "Heading Background Hover Colour",
    options: [].concat(themeColours),
    value: headerBackgroundHoverColour,
    onChange: function onChange(e) {
      _onChange({
        headerBackgroundHoverColour: e.value
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: "Heading Font",
    options: [].concat(themeFonts),
    value: headerFont,
    onChange: function onChange(e) {
      _onChange({
        headerFont: e.value
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_Slider["default"], {
    label: "Heading Font Size",
    min: 0,
    max: 5,
    step: 1,
    value: headerFontSize,
    onChange: function onChange(e) {
      return _onChange({
        headerFontSize: e.target.value
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: "Heading Font Weight",
    options: [{
      label: 'Light',
      value: 'light'
    }, {
      label: 'Normal',
      value: 'normal'
    }, {
      label: 'Bold',
      value: 'bold'
    }],
    value: headerFontWeight,
    onChange: function onChange(e) {
      _onChange({
        headerFontWeight: e.value
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: "Border Colour",
    options: [{
      label: 'None',
      value: ''
    }].concat(themeColours),
    value: borderColour,
    onChange: function onChange(e) {
      _onChange({
        borderColour: e.value
      });
    }
  })), /*#__PURE__*/_react["default"].createElement("hr", {
    className: "my-2",
    style: {
      borderTop: '1px solid #666'
    }
  }), selectedAccordionIndex !== null && accordion && accordion[selectedAccordionIndex] && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_PlainTextarea["default"], {
    label: "Heading Text",
    onChange: function onChange(e) {
      var accordionClone = _toConsumableArray(accordion);

      accordionClone[selectedAccordionIndex].label = e.target.value;

      _onChange({
        accordion: accordionClone
      });
    },
    onBlur: function onBlur(e) {
      if (!!accordion[selectedAccordionIndex].anchor === false) {
        var accordionClone = _toConsumableArray(accordion);

        accordionClone[selectedAccordionIndex].anchor = e.target.value.replace(/\W/g, '_').toLowerCase().substr(0, 30);

        _onChange({
          accordion: accordionClone
        });
      }
    },
    value: accordion[selectedAccordionIndex].label
  }), /*#__PURE__*/_react["default"].createElement(_Textarea["default"], {
    label: "Accordion Content",
    onChange: function onChange(e, editor) {
      var accordionClone = _toConsumableArray(accordion);

      accordionClone[selectedAccordionIndex].text = editor.getData();

      _onChange({
        accordion: accordionClone
      });
    },
    value: accordion[selectedAccordionIndex].text
  }), /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    label: "Open By Default",
    checked: accordion[selectedAccordionIndex].openByDefault,
    onChange: function onChange(e) {
      var accordionClone = _toConsumableArray(accordion);

      accordionClone[selectedAccordionIndex].openByDefault = e.target.checked;

      _onChange({
        accordion: accordionClone
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    label: "Anchor",
    onChange: function onChange(e) {
      var accordionClone = _toConsumableArray(accordion);

      accordionClone[selectedAccordionIndex].anchor = e.target.value;

      _onChange({
        accordion: accordionClone
      });
    },
    onBlur: function onBlur(e) {
      var accordionClone = _toConsumableArray(accordion);

      var currentAnchor = accordionClone[selectedAccordionIndex].anchor;
      accordionClone[selectedAccordionIndex].anchor = currentAnchor.replace(/\W/g, '_').toLowerCase().substr(0, 30);

      _onChange({
        accordion: accordionClone
      });
    },
    value: accordion[selectedAccordionIndex].anchor
  }), /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-sm btn-danger w-100 mt-2",
    onClick: function onClick(e) {
      var accordionClone = _toConsumableArray(accordion);

      accordionClone.splice(selectedAccordionIndex, 1);

      _onChange({
        accordion: accordionClone
      });
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faTrash.faTrash,
    className: "mr-2"
  }), " Remove Accordion Item")), selectedAccordionIndex !== null && (accordion === null || accordion === void 0 ? void 0 : accordion.length) > 0 && /*#__PURE__*/_react["default"].createElement("hr", {
    className: "my-2",
    style: {
      borderTop: '1px solid #666'
    }
  }), /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-sm btn-secondary w-100",
    onClick: function onClick(e) {
      var accordionClone = [].concat(_toConsumableArray(accordion), [_objectSpread(_objectSpread({}, DEFAULT_ACCORDION_ITEM), {}, {
        label: "Item Heading ".concat(accordion.length + 1),
        anchor: "item_heading_".concat(accordion.length + 1)
      })]);

      _onChange({
        accordion: accordionClone
      });
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faPlusCircle.faPlusCircle,
    className: "mr-2"
  }), " Add Accordion Item")));
};

var _default = AccordionForm;
exports["default"] = _default;